import { useRef, useState, useMemo } from "react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import LoadingOverlay from "src/components/common/form/LoadingOverlay";
import { Message } from "src/components/common/form/Message";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

import useUiuxStore from "src/store/useUiuxStore";


import { useMouseContent } from "src/utils/mouse/mouseContent";

import { Content_WMS1100_R01 } from "./Content_WMS1100_R01";
// import { Info_WMS1100_R01 } from "./Info_WMS1100_R01";
import { useWMS1100_R01Store } from "./Store_WMS1100_R01";
import { AgGridReact } from "ag-grid-react";
import { WMS1100_R01DetailDto, WMS1100_R01Dto, WMS1100_R01HeaderDto, WMS1100_R01LotDto } from "./Dto_WMS1100_R01";
// import SearchSection_WMS1100_R01 from "./SearchSection_WMS1100_R01";
// import { Table_WMS1100_R01 } from "./Table_WMS1100_R01";
import { LabelPrintButton } from "src/components/common/LabelPrintButton";
import SearchSection_WMS1100_R01 from "./SearchSection_WMS1100_R01";
import { Table_WMS1100_R01 } from "./Table_WMS1100_R01";
import { DetailTable_WMS1100_R01 } from "./DetailTable_WMS1100_R01";
import { LotTable_WMS1100_R01 } from "./LotTable_WMS1100_R01";


export const Container_WMS1100_R01 = () => {

	const { tabList, setMessage } = useUiuxStore();

	const RESIZER = {
		code: 'WMS1100_R01',
		type: 'width',
		storageKey: 'WMS1100_R01-split-width',
		min: 5,
		max: 80,
		default: 27
	} as const;

	const RESIZER2 = {
		code: 'WMS1100_R01_2',
		type: 'width',
		storageKey: 'WMS1100_R01-split-width-2',
		min: 5,
		max: 80,
		default: 70
	} as const;

	const gridRef = useRef<AgGridReact<WMS1100_R01HeaderDto>>(null);
	const lotGridRef = useRef<AgGridReact<WMS1100_R01LotDto>>(null);
	const detailGridRef = useRef<AgGridReact<WMS1100_R01DetailDto>>(null);

	const containerRef = useRef<HTMLDivElement>(null);
	const rightPanelRef = useRef<HTMLDivElement>(null);
	const infoRef = useRef<HTMLDivElement>(null);
	const isResizing = useRef(false);
	const isResizing2 = useRef(false);

	const { 
		splitValue,
		handleMouseDown,
		handleMouseUp
	} = useMouseContent({
		resizer: RESIZER,
		isResizing,
		containerRef,
		infoRef
	});

	const { 
		splitValue: splitValue2,
		handleMouseDown: handleMouseDown2,
		handleMouseUp: handleMouseUp2
	} = useMouseContent({
		resizer: RESIZER2,
		isResizing: isResizing2,
		containerRef: rightPanelRef,
		infoRef
	});

	const {
		handleExcelClick,
		fetchData,
		defaultWMS1100_R01HeaderRow,
		defaultWMS1100_R01DetailRow,
		defaultWMS1100_R01LotRow,
		initContainerData,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
		handleFetchDetailList,
	} = Content_WMS1100_R01({
		gridRef,
		lotGridRef,
		detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
		
	});

	return <div className={`content-container`}>
		
		<Actionbar
			onFetchClick={fetchData}
			onCreateClick={() => {}} //onCreateClick={handleCreateClick} < 예외입고 과정 알려주기 전까지 잠그기
			onDeleteClick={handleDeleteClick}
			onSaveClick={handleSaveClick}
			onPrintClick={() => {}}
			onExcelClick={handleExcelClick}
			onInitClick={initContainerData}
		/>
		<SearchSection_WMS1100_R01 onEnterKeyDown={() => { fetchData(); }} />

		<div className="flex flex-1 p-[12px] gap-[4px] min-h-0"
			ref={containerRef}>
			{/* 첫 번째 패널: Table */}
			<div className="h-full" style={{ width: `${splitValue}%` }}>
				<Table_WMS1100_R01 gridRef={gridRef} handleCreateClick={handleCreateClick} />
			</div>
			{/* 리사이저 1 */}
			<div
				className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
				onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown('LR', e.nativeEvent)}
				data-comment="리사이저1"
			/>
			<div className="flex h-full gap-[4px]" style={{ width: `${100 - splitValue}%` }} ref={rightPanelRef}>
				{/* 두 번째 패널: DetailTable */}
				<div className="h-full" style={{ width: `${splitValue2}%` }}>
					<DetailTable_WMS1100_R01 
						detailGridRef={detailGridRef}
						defaultWMS1100_R01DetailRow={defaultWMS1100_R01DetailRow()}
					/>
				</div>
				{/* 리사이저 2 */}
				<div
					className="w-[6px] bg-gray-100 cursor-col-resize hover:bg-gray-300"
					onMouseDown={(e: React.MouseEvent<HTMLDivElement>) => handleMouseDown2('LR', e.nativeEvent)}
					data-comment="리사이저2"
				/>
				{/* 세 번째 패널: LotTable */}
				<div className="h-full" style={{ width: `${100 - splitValue2}%` }} ref={infoRef}>
					<LotTable_WMS1100_R01 
						lotGridRef={lotGridRef}
						defaultWMS1100_R01LotRow={defaultWMS1100_R01LotRow()}
					/>
				</div>
			</div>
		</div>
		<Message />
	</div>
}